<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import { initSentryContext } from '@/plugins'
import { Toaster } from '@/ui'

const route = useRoute()

const requiresAuth = computed(() => route.matched.some(record => record.meta.requiresAuth && !record.meta.emptyLayout))

// Initialize Sentry context watchers (runs in background)
initSentryContext().catch(error => {
  console.error('Failed to initialize Sentry context:', error)
})
</script>

<template>
  <component :is="requiresAuth ? DefaultLayout : EmptyLayout">
    <RouterView />
  </component>
  <Toaster />
</template>
